<template>
  <div class="fee-detail-wrapper">
    <el-dialog
      :visible.sync="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      @close="handleClose"
      class="fee-detail-dialog"
    >
    <template #title>
        <div class="dialog-title-box">
          <span>{{title}}</span>
          <rhcn-button
            class="icon-button dialog-close-icon"
            size="small"
            @click="handleClose"
          ><i class="el-icon-close"></i></rhcn-button>
        </div>
      </template>
      <div v-loading="loading">
        <div class="fee-detail-content">
          <!-- 处理费详情 -->
          <div v-if="data && data.type === 'HANDLING'" class="fee-detail-table">
            <div class="fee-detail-row header-row">
              <div class="fee-detail-cell">Processing fee Fixed amount</div>
            </div>
            <div class="fee-detail-row">
              <div class="fee-detail-cell">{{ formatAmount(data.data.feeFixedAmount, data.data.feeCurrency) }}</div>
            </div>
          </div>

          <!-- 手续费详情 -->
          <div v-if="data && data.type === 'FEE'" class="fee-detail-table">
            <div class="fee-detail-row header-row">
              <div class="fee-detail-cell">Fee Percentage</div>
              <div class="fee-detail-cell">Fee Percentage amount</div>
            </div>
            <div class="fee-detail-row">
              <div class="fee-detail-cell">{{ data.data.percentRate ? `${data.data.percentRate}%` : '--' }}</div>
              <div class="fee-detail-cell">{{ formatAmount(data.data.feePercentAmount, data.data.feeCurrency) }}</div>
            </div>
          </div>

          <!-- Markup详情 -->
          <div v-if="data && data.type === 'MARKUP'" class="fee-detail-table">
            <div class="fee-detail-row header-row">
              <div class="fee-detail-cell">Markup Fixed amount</div>
              <div class="fee-detail-cell">Markup Fixed rate</div>
              <div class="fee-detail-cell">Markup Percentage</div>
              <div class="fee-detail-cell">Markup Percentage amount</div>
            </div>
            <div class="fee-detail-row">
              <div class="fee-detail-cell">{{ formatAmount(data.data.feeFixedAmount, data.data.feeCurrency) }}</div>
              <div class="fee-detail-cell">{{ data.data.exchangeRate || '--' }}</div>
              <div class="fee-detail-cell">{{ data.data.percentRate ? `${data.data.percentRate}%` : '--' }}</div>
              <div class="fee-detail-cell">{{ formatAmount(data.data.feePercentAmount, data.data.settleCurrency) }}</div>
            </div>
          </div>
        </div>
        <div class="fee-detail-placeholder"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RhcnButton from '@/components/form/button.vue';
export default {
  name: 'FeeDetail',
  components: {
    RhcnButton,
  },
  data() {
    return {
      visible: false,
      loading: false,
      data: null,
      titleMap: {
        HANDLING: 'Processing fee details',
        FEE: 'Fee details',
        MARKUP: 'Markup fee details',
      },
    };
  },
  computed: {
    title() {
      return this.data ? this.titleMap[this.data.type] : '';
    },
  },
  methods: {
    formatAmount(amount, currency) {
      if (!amount || !currency) return '--';
      return `${amount}${currency}`;
    },
    open(data) {
      this.visible = true;
      this.loading = false;
      this.data = {
        type: data.type,
        data: data.data,
      };
    },
    handleClose() {
      this.visible = false;
      this.loading = false;
      this.data = null;
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.fee-detail-content {
  width: 100%;
  background-color: #fff;
}

.fee-detail-table {
  width: 100%;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.fee-detail-row {
  display: flex;
  border-bottom: 1px solid #EBEEF5;

  &:last-child {
    border-bottom: none;
  }

  &.header-row {
    background-color: #F5F7FA;

    .fee-detail-cell {
      font-weight: 500;
      color: #606266;
      text-align: center;
    }
  }
}

.fee-detail-cell {
  flex: 1;
  padding: 12px 16px;
  text-align: center;
  font-size: 14px;
  color: #333;
  line-height: 1.5;

  &:not(:last-child) {
    border-right: 1px solid #EBEEF5;
  }
}

.fee-detail-placeholder {
  height: 30px;
}

.fee-detail-wrapper {
  :deep(.el-dialog) {
    .el-dialog__header {
      padding: 0;
      border-bottom: 1px solid rgba(0,32,63,0.08);
    }
    .el-dialog__body {
      padding: 30px 35px;
      padding-bottom: 32px;
      max-height: 60vh;
      overflow-y: auto;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }

  .dialog-title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 20px 30px 11px;

    span {
      font-size: 20px;
      font-weight: 800;
      line-height: 36px;
    }

    .dialog-close-icon {
      width: 27px !important;
      height: 27px !important;
      min-width: 27px !important;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $color-white;
      border: none;
      padding: 0;

      &:hover {
        background-color: $color-default;
      }
      &:active {
        background-color: $color-default-active;
      }

      .el-icon-close {
        font-weight: bold;
        color: $color-primary;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
